import {registerMiddleware} from '@homeaway/redux-middleware-adapter';
import registerSegmentationMiddleware from '../react-segmentation/middleware/registerMiddleware';
import tripDataDidChange from './trip/trip';
import locationDidChange from './location/location';
import redirectInterceptor from './redirectInterceptor/redirectInterceptor';
import {parseSearchParams} from './searchParams/searchParams';
import modals from './modals/modals';
import {
    userAgentDidChange,
    syncMapMarkersToLocalStorage,
    mapPinHighlighted,
    mapLoaded
} from './map/map';
import routerActions from '../actions/router';
import {registerAllMiddleware as registerTripboardMiddleware} from '@homeaway/react-trip-board-button';

import {
    MAP_ADD_MARKER_CLICKED,
    MAP_HIGHLIGHT_PIN,
    MAP_LOADED
} from '../actions/map';
import {SEARCHPARAMS_SET} from '../actions/searchParams';
import {REDIRECT_PERFORM} from '../actions/redirect';
import {VIEWPORT_USER_AGENT_CHANGED} from '../actions/viewport';
import setLastSearchUrl from './location/setLastSearchUrl';
import applyFilterEdapEvents from './filter/applyFilterEdapEvents';

/* istanbul ignore next */
function registerAllMiddleware() {
    // List out all middleware functions and the action that they respond to
    registerMiddleware(routerActions.LOCATION_CHANGED, modals);
    registerMiddleware(routerActions.LOCATION_CHANGED, parseSearchParams);
    registerMiddleware(routerActions.LOCATION_CHANGED, setLastSearchUrl);
    registerMiddleware(routerActions.LOCATION_CHANGED, applyFilterEdapEvents);
    registerMiddleware(REDIRECT_PERFORM, redirectInterceptor);
    registerMiddleware(SEARCHPARAMS_SET, tripDataDidChange);
    registerMiddleware(SEARCHPARAMS_SET, locationDidChange);
    registerMiddleware(VIEWPORT_USER_AGENT_CHANGED, userAgentDidChange);
    registerMiddleware(MAP_ADD_MARKER_CLICKED, syncMapMarkersToLocalStorage);
    registerMiddleware(MAP_HIGHLIGHT_PIN, mapPinHighlighted);
    registerMiddleware(MAP_LOADED, mapLoaded);
    registerTripboardMiddleware();
    registerSegmentationMiddleware();
}

export default registerAllMiddleware;
